// extracted by mini-css-extract-plugin
module.exports = {"shadow":"GradientSVG_shadow__3od7s"};